<template>
  <div class="tw-grid tw-grid-rows-5 tw-gap-2">
    <div v-for="(rating, index) in ratings" :key="index" class="tw-flex tw-flex-nowrap tw-gap-x-2">
      <CustomCheckbox
        :value="rating.rating"
        :boxCheckColor="$page.props.customisation.primary_background"
        :checked="modelValue.includes(rating.rating)"
        @update:modelValue="selectRating"
      />

      <RatingStars :highlightedNumbers="rating.rating" :starCount="5" />

      <div class="tw-mt-1.5 tw-flex-1">
        <ProgressBar
          class="!tw-h-1.5"
          :value="percentageTotal(rating.total, totalReviews)"
          :showValue="false"
          :pt="{
            value: { class: '!tw-bg-yellow-500' },
          }"
        />
      </div>

      <div class="tw-box-content tw-min-w-[15px] tw-text-right tw-text-sm tw-font-medium tw-text-gray-500">
        {{ Number(rating.total).toLocaleString() }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  ratings: Array,
  totalReviews: Number,
  modelValue: Array,
});

const emit = defineEmits(['update:modelValue']);

const selectRating = (isChecked, rating) => {
  const selectedRatings = [...props.modelValue];

  if (isChecked) {
    selectedRatings.push(rating);
  } else {
    selectedRatings.splice(selectedRatings.indexOf(rating), 1);
  }

  emit('update:modelValue', selectedRatings);
};

const percentageTotal = computed(() => {
  return (count, total) => {
    return count > 0 && total > 0 ? (count / total) * 100 : 0;
  };
});
</script>
